import { messageBaseModel } from './crud';

export * from './types';

export const useMessagesById = messageBaseModel.fetchById();
export const useMessagesByIds = messageBaseModel.fetchByIds();
export const useMessagesMany = messageBaseModel.fetchMany();
export const useMessagesCount = messageBaseModel.count();
export const useMessagesManyInfiniteQuery = messageBaseModel.fetchPaginated();
export const useMessagesUpdateOne = messageBaseModel.edit();
export const useMessagesCreateOne = messageBaseModel.create();
export const useMessagesRemoveOne = messageBaseModel.delete();
export const useMessagesRemoveByIds = messageBaseModel.deleteByIds();

export const useMessagesByIdV2 = messageBaseModel.fetchByIdV2();
export const useMessagesByIdsV2 = messageBaseModel.fetchByIdsV2();
export const useMessagesManyV2 = messageBaseModel.fetchManyV2();
export const useMessagesCountV2 = messageBaseModel.countV2();
export const useMessagesManyInfiniteQueryV2 =
  messageBaseModel.fetchPaginatedV2();
export const useMessagesUpdateOneV2 = messageBaseModel.editV2();
export const useMessagesCreateOneV2 = messageBaseModel.createV2();
export const useMessagesRemoveOneV2 = messageBaseModel.deleteV2();
export const useMessagesRemoveByIdsV2 = messageBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useMessageById = messageBaseModel.fetchById();
export const useMessageByIds = messageBaseModel.fetchByIds();
export const useMessageMany = messageBaseModel.fetchMany();
export const useMessageCount = messageBaseModel.count();
export const useMessagePagination = messageBaseModel.fetchPaginated();
export const useMessageUpdateOne = messageBaseModel.edit();
export const useMessageCreateOne = messageBaseModel.create();
export const useMessageRemoveOne = messageBaseModel.delete();
export const useMessageRemoveByIds = messageBaseModel.deleteByIds();

export const useMessageByIdV2 = messageBaseModel.fetchByIdV2();
export const useMessageByIdsV2 = messageBaseModel.fetchByIdsV2();
export const useMessageManyV2 = messageBaseModel.fetchManyV2();
export const useMessageCountV2 = messageBaseModel.countV2();
export const useMessagePaginationV2 = messageBaseModel.fetchPaginatedV2();
export const useMessageUpdateOneV2 = messageBaseModel.editV2();
export const useMessageCreateOneV2 = messageBaseModel.createV2();
export const useMessageRemoveOneV2 = messageBaseModel.deleteV2();
export const useMessageRemoveByIdsV2 = messageBaseModel.deleteByIdsV2();
